export class ModalMessage {

    public static AddStay():string { return "Séjour ajouté avec succés !"}
}